'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareProjectShowFBPopup = exports.shareProjectPopupOpened = exports.shareProjectFailure = exports.shareProjectGotFBLink = exports.shareProjectSuccess = undefined;
exports.setProjectsList = setProjectsList;
exports.addProject = addProject;
exports.addDefaultProject = addDefaultProject;
exports.updateProjectName = updateProjectName;
exports.setProject = setProject;
exports.updateNode = updateNode;
exports.updateNodes = updateNodes;
exports.removeEdge = removeEdge;
exports.detachNode = detachNode;
exports.confirmRemoveNode = confirmRemoveNode;
exports.removeNode = removeNode;
exports.addNode = addNode;
exports.appendNewNode = appendNewNode;
exports.appendRightConnectedNode = appendRightConnectedNode;
exports.appendBottomConnectedNode = appendBottomConnectedNode;
exports.appendRightNode = appendRightNode;
exports.addEdge = addEdge;
exports.setPermission = setPermission;
exports.projectDelete = projectDelete;
exports.shareProject = shareProject;

var _actionTypes = require('../constants/actionTypes');

var _popupTypes = require('../constants/popupTypes');

var _popupActions = require('./popupActions');

var _projectActions = require('sagas/projectActions');

var _projectSimpleStubbedData = require('reducers/projectSimpleStubbedData');

var _projectSimpleStubbedData2 = _interopRequireDefault(_projectSimpleStubbedData);

var _defaultProjectData = require('reducers/defaultProjectData');

var _defaultProjectData2 = _interopRequireDefault(_defaultProjectData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO move!

/* injects from baggage-loader */

function setProjectsList(value) {
  return {
    type: _actionTypes.SET_PROJECTS_LIST,
    value: value
  };
}

function addProject() {
  var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var transition = params.transition;


  return function (dispatch, getState) {
    var user = getState().user.authorizedUser;
    if (user) {
      dispatch({
        type: _actionTypes.ADD_PROJECT,
        userId: user.id,
        transition: transition,
        project: (0, _projectSimpleStubbedData2.default)()
      });
    }
  };
}

function addDefaultProject() {
  return function (dispatch, getState) {
    var user = getState().user.authorizedUser;
    dispatch({
      type: _actionTypes.ADD_PROJECT,
      userId: user.id,
      transition: false,
      project: (0, _defaultProjectData2.default)()
    });
  };
}

function updateProjectName(projectId, value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes.UPDATE_PROJECT_NAME,
      projectId: projectId,
      value: value
    });
  };
}

function setProject(value) {
  return {
    type: _actionTypes.SET_PROJECT,
    value: value
  };
}

function updateNode(nodeId, data) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.UPDATE_NODE,
      projectId: projectId,
      nodeId: nodeId,
      data: data
    });
  };
}

function updateNodes(nodesIds, nodesData) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;


    dispatch({
      type: _actionTypes.UPDATE_NODES,
      projectId: projectId,
      nodesIds: nodesIds,
      nodesData: nodesData
    });
  };
}

function removeEdge(edgeId) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.REMOVE_EDGE,
      projectId: projectId,
      edgeId: edgeId
    });
  };
}

function detachNode(nodeId) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.DETACH_NODE,
      projectId: projectId,
      nodeId: nodeId
    });
  };
}

function confirmRemoveNode(nodeId) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch((0, _popupActions.popupShow)(_popupTypes.PROJECT_CONFIRM_REMOVE_NODE, { nodeId: nodeId, projectId: projectId }));
  };
}

function removeNode(nodeId) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.REMOVE_NODE,
      projectId: projectId,
      nodeId: nodeId
    });
  };
}

function addNode(_ref) {
  var _ref$x = _ref.x;
  var x = _ref$x === undefined ? 0 : _ref$x;
  var _ref$y = _ref.y;
  var y = _ref$y === undefined ? 0 : _ref$y;
  var _ref$caption = _ref.caption;
  var caption = _ref$caption === undefined ? 'caption' : _ref$caption;
  var _ref$color = _ref.color;
  var color = _ref$color === undefined ? '#555' : _ref$color;

  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.ADD_NODE,
      projectId: projectId,
      nodeData: { caption: caption, color: color, x: x, y: y }
    });
  };
}

function appendNewNode(_ref2) {
  var id = _ref2.id;
  var _ref2$x = _ref2.x;
  var x = _ref2$x === undefined ? 0 : _ref2$x;
  var _ref2$y = _ref2.y;
  var y = _ref2$y === undefined ? 0 : _ref2$y;
  var _ref2$caption = _ref2.caption;
  var caption = _ref2$caption === undefined ? 'caption' : _ref2$caption;
  var _ref2$color = _ref2.color;
  var color = _ref2$color === undefined ? '#555' : _ref2$color;

  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.APPEND_NEW_NODE,
      projectId: projectId,
      newNodeData: { caption: caption, color: color, x: x, y: y },
      id: id
    });
  };
}

function appendRightConnectedNode(_ref3) {
  var id = _ref3.id;
  var _ref3$x = _ref3.x;
  var x = _ref3$x === undefined ? 0 : _ref3$x;
  var _ref3$y = _ref3.y;
  var y = _ref3$y === undefined ? 0 : _ref3$y;
  var _ref3$caption = _ref3.caption;
  var caption = _ref3$caption === undefined ? 'caption' : _ref3$caption;
  var _ref3$color = _ref3.color;
  var color = _ref3$color === undefined ? '#555' : _ref3$color;

  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.APPEND_RIGHT_CONNECTED_NODE,
      projectId: projectId,
      newNodeData: { caption: caption, color: color, x: x, y: y },
      id: id
    });
  };
}

function appendBottomConnectedNode(_ref4) {
  var id = _ref4.id;
  var _ref4$x = _ref4.x;
  var x = _ref4$x === undefined ? 0 : _ref4$x;
  var _ref4$y = _ref4.y;
  var y = _ref4$y === undefined ? 0 : _ref4$y;
  var _ref4$caption = _ref4.caption;
  var caption = _ref4$caption === undefined ? 'caption' : _ref4$caption;
  var _ref4$color = _ref4.color;
  var color = _ref4$color === undefined ? '#555' : _ref4$color;

  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.APPEND_BOTTOM_CONNECTED_NODE,
      projectId: projectId,
      newNodeData: { caption: caption, color: color, x: x, y: y },
      id: id
    });
  };
}

function appendRightNode(_ref5) {
  var id = _ref5.id;
  var _ref5$x = _ref5.x;
  var x = _ref5$x === undefined ? 0 : _ref5$x;
  var _ref5$y = _ref5.y;
  var y = _ref5$y === undefined ? 0 : _ref5$y;
  var _ref5$caption = _ref5.caption;
  var caption = _ref5$caption === undefined ? 'caption' : _ref5$caption;
  var _ref5$color = _ref5.color;
  var color = _ref5$color === undefined ? '#555' : _ref5$color;

  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.APPEND_RIGHT_NODE,
      projectId: projectId,
      newNodeData: { caption: caption, color: color, x: x, y: y },
      id: id
    });
  };
}

function addEdge(from, to) {
  return function (dispatch, getState) {
    var projectId = getState().routing.params.projectId;

    dispatch({
      type: _actionTypes.ADD_EDGE,
      projectId: projectId,
      from: from,
      to: to
    });
  };
}

function setPermission(userId, projectId, isPublic, isListed) {
  return {
    type: _actionTypes.SET_PERMISSION,
    userId: userId,
    projectId: projectId,
    isPublic: isPublic,
    isListed: isListed
  };
}

function projectDelete(project) {
  return {
    type: _actionTypes.DELETE_PROJECT,
    project: project
  };
}

function shareProject(project) {
  return function (dispatch, getState) {
    var user = getState().user.authorizedUser;

    var userId = user.id;
    var userName = user.displayName;

    dispatch({
      type: _actionTypes.SHARE_PROJECT,
      project: project, userId: userId, userName: userName
    });
  };
}

var shareProjectSuccess = exports.shareProjectSuccess = function shareProjectSuccess() {
  return { type: _actionTypes.SHARE_PROJECT_SUCCESS };
};
var shareProjectGotFBLink = exports.shareProjectGotFBLink = function shareProjectGotFBLink(link) {
  return {
    type: _actionTypes.SHARE_PROJECT_GOT_FB_LINK,
    link: link
  };
};
var shareProjectFailure = exports.shareProjectFailure = function shareProjectFailure() {
  return { type: _actionTypes.SHARE_PROJECT_FAILURE };
};
var shareProjectPopupOpened = exports.shareProjectPopupOpened = function shareProjectPopupOpened() {
  return { type: _actionTypes.SHARE_PROJECT_POPUP_OPENED };
};
var shareProjectShowFBPopup = exports.shareProjectShowFBPopup = function shareProjectShowFBPopup(link) {
  (0, _projectActions.showProjectShareFBPopup)(link);

  return function (dispatch) {
    dispatch(shareProjectPopupOpened());
    dispatch(shareProjectSuccess());
    dispatch((0, _popupActions.popupCloseLast)());
  };
};


//////////////////
// WEBPACK FOOTER
// ./app/actions/projectsActions.js
// module id = 22
// module chunks = 1